'use client';

import { ArrowRight, Mail, Phone } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export default function CTA() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className="rounded-3xl p-8 md:p-16 relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #006546 0%, #19ffb5 100%)' }}
        >
          {/* Pattern Overlay */}
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.15) 2px, rgba(0,0,0,0.15) 4px), repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(0,0,0,0.15) 2px, rgba(0,0,0,0.15) 4px)', backgroundSize: '4px 4px' }} />
          {/* Subtle radial overlay for depth */}
          <div className="absolute inset-0" style={{ background: 'radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08) 0%, transparent 50%)' }} />

          <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-5xl font-semibold text-black mb-6">
                {t('cta.title')}
              </h2>
              <p className="text-black/75 text-lg mb-8 font-light max-w-md">
                {t('cta.description')}
              </p>

              <div className="space-y-4">
                <div className="flex items-center gap-3 text-black font-semibold">
                  <div className="w-10 h-10 bg-black/10 rounded-full flex items-center justify-center">
                    <Mail className="w-5 h-5" />
                  </div>
                  hello@webzuk.com
                </div>
                <div className="flex items-center gap-3 text-black font-semibold">
                  <div className="w-10 h-10 bg-black/10 rounded-full flex items-center justify-center">
                    <Phone className="w-5 h-5" />
                  </div>
                  +1 (555) 123-4567
                </div>
              </div>
            </div>

            <div className="bg-black p-8 rounded-2xl shadow-2xl">
              <form className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-widest">{t('cta.form.name')}</label>
                    <input type="text" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#19ffb5] focus:shadow-[0_0_0_3px_rgba(25,255,181,0.1)] transition-all" placeholder="John Doe" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-widest">{t('cta.form.company')}</label>
                    <input type="text" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#19ffb5] focus:shadow-[0_0_0_3px_rgba(25,255,181,0.1)] transition-all" placeholder="Acme Inc" />
                  </div>
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-semibold text-gray-400 uppercase tracking-widest">{t('cta.form.email')}</label>
                  <input type="email" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#19ffb5] focus:shadow-[0_0_0_3px_rgba(25,255,181,0.1)] transition-all" placeholder="john@example.com" />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-semibold text-gray-400 uppercase tracking-widest">{t('cta.form.message')}</label>
                  <textarea rows={4} className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#19ffb5] focus:shadow-[0_0_0_3px_rgba(25,255,181,0.1)] transition-all" placeholder="Tell us about your project..." />
                </div>
                <button type="button" className="w-full bg-[#030302] hover:bg-[#1a1a19] text-white font-semibold py-4 rounded-full transition-all duration-250 flex items-center justify-center gap-2 hover:-translate-y-0.5">
                  {t('cta.form.send')}
                  <ArrowRight className="w-4 h-4" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
